import { render, staticRenderFns } from "./SDSelectBox.vue?vue&type=template&id=4ae41e38&scoped=true&"
import script from "./SDSelectBox.vue?vue&type=script&lang=ts&"
export * from "./SDSelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./SDSelectBox.vue?vue&type=style&index=0&id=4ae41e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae41e38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae41e38')) {
      api.createRecord('4ae41e38', component.options)
    } else {
      api.reload('4ae41e38', component.options)
    }
    module.hot.accept("./SDSelectBox.vue?vue&type=template&id=4ae41e38&scoped=true&", function () {
      api.rerender('4ae41e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/SDSelectBox.vue"
export default component.exports